<template>

  <v-container fluid>
    <div class="mt-1" style="max-width:1024px;margin:auto">
      <v-row>
        <v-col cols="12" class="">
          <v-data-table
              @click:row="(item) => goToAgency(item)"
              :headers="listing.headers"
              :loading="loading"
              :items="listing.items"
              :hide-default-footer="true"
              :footer-props="{
            'items-per-page-options': listing.rowsPerPageItems,
            'items-per-page-text': 'Lignes par page',
          }"
              class="elevation-1 tbl"
              no-data-text="Aucune agence n'a jamais été visitée"
          >
            <template #item.agencyName="{ item, value }">
              <div>{{ value }}</div>
              <span class="caption grey--text text--darken-1">
                {{ item.address.street }}
                {{ item.address.postalCode }}
                - {{ item.address.city }}
                {{ item.address.country != 'FRANCE' ? " - " + item.address.country : '' }}
              </span>
            </template>

            <template #item.creationDate="{item, value}">
              <div>
                {{ _parseAndFormatDate(value, "dd/MM/yyyy HH:mm:ss", "dd/MM/yyyy' à 'HH'h'mm") }}
              </div>
            </template>

            <template #item.marketingAreaName="{item, value}">
              <div>
                <v-chip label outlined small>{{ value }}</v-chip>
              </div>
            </template>

            <template #item.actions>
              <div class="mr-3">
                <v-icon size="15">mdi-open-in-new</v-icon>
              </div>
            </template>

          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>


</template>
<script>
import {post} from "@/utils/api";
import {EventBus} from "@/components/commons/event-bus";

export default {
  name: "CommercialNotVisited",
  components: {},
  data() {
    return {
      listing: {
        headers: [
          {
            text: "Agence",
            value: "agencyName",
            width: '45%'
          },
          {
            text: "Date création",
            value: "creationDate",
            sortable: false,
            width: '25%'
          },
          {
            text: "Zone commerciale",
            value: "marketingAreaName",
            width: '25%'
          },
          {
            text: "",
            align: "right",
            value: "actions",
            sortable: false,
            width: '5%'
          }
        ],
        items: [],
        rowsPerPageItems: [{text: "Tous", value: -1}, 50, 200],
        pagination: {
          options: {
            page: 1,
            itemsPerPage: 200,
            sortBy: [],
            sortDesc: [false],
          },
        }
      },
      loading: false
    }
  },
  created() {
    EventBus.$on("loading-not-visited", (searchForm) => {
      this.loadData(searchForm)
    });
  },
  destroyed() {
    EventBus.$off("loading-not-visited")
  },
  methods: {
    loadData(context) {
      const url = "/api/agency/crm/no-event";
      if (!this.loading) {
        this.listing.items = []
        this.loading = true

        const ctx = {
          ...context, marketingAreaIds: context.marketingAreaIds.map(maId => {
            return maId.id
          })
        }
        post(url, ctx)
            .badRequest((br) => {
            EventBus.$emit('toaster-error', "Erreur lors de la récupération des données")
            console.log("Error: ", br);
          }).json((data) => {
          this.listing.items = data
          this.loading = false
        });
      }
    },
    goToAgency(agency) {
      const url = `/hlagons/crm/${agency.agencyId}`;
      window.open(url, "_blank");
    },
  },
}
</script>
